<template>
    <div class="content_box device-manage">
        <div class="content">
            <div class="top">
                <div class="title">
                    <span>设备详情</span>
                </div>
            </div>
            <div class="user">
                <div class="header">
                    <p class="info_title">{{ baseInfo.deviceName }}&nbsp;
                        <span v-if="baseInfo.status==1" class="status1">在线</span>
                        <span v-else-if="baseInfo.status==0" class="status2">未激活</span>
                        <span v-else-if="baseInfo.status==3" class="status3">离线</span>
                        <span v-else-if="baseInfo.status==8">已禁用</span>
                    </p><br>
                    <el-descriptions class="user_info" :column="4">
                        <el-descriptions-item label="产品名称">{{ baseInfo.productName || '--'}}</el-descriptions-item>
                        <el-descriptions-item label="ProductKey">{{ baseInfo.productKey }}
                            <el-button type="text" class="copy" v-clipboard="baseInfo.productKey"
                                v-clipboard:success="copySuccess" v-clipboard:error="copyError">
                                <img src="../../../assets/images/copy.png" alt="">
                            </el-button>
                        </el-descriptions-item>
                        <el-descriptions-item label="DeviceSecret">{{encrypt(baseInfo.deviceSecret,2,2) }}
                            <el-button type="text" class="copy" v-clipboard="baseInfo.deviceSecret"
                                v-clipboard:success="copySuccess" v-clipboard:error="copyError">
                                <img src="../../../assets/images/copy.png" alt="">
                            </el-button>
                        </el-descriptions-item>
                    </el-descriptions>
                    <template v-if="roleCheck('104-102-101-102')">
                        <el-descriptions class="active" :column="4" v-if="isCatBox">
                            <el-descriptions-item label="仓门操作">
                                <div class="button text door" @click="doorHandle('open')">开启</div>
                                <div class="button text door" @click="doorHandle('close')">关闭</div>
                            </el-descriptions-item>
                        </el-descriptions>
                    </template>
                </div>
                <div class="main">
                    <template>
                        <el-tabs v-model="activeName">
                            <el-tab-pane label="设备信息" name="a">
                                <el-descriptions class="login_info" :column="3">
                                    <el-descriptions-item label="DeviceName">{{ baseInfo.deviceName }}
                                        <el-button type="text" class="copy" v-clipboard="baseInfo.deviceName"
                                            v-clipboard:success="copySuccess" v-clipboard:error="copyError">
                                            <img src="../../../assets/images/copy.png" alt="">
                                        </el-button>
                                    </el-descriptions-item>
                                    <el-descriptions-item label="ProductKey">{{ baseInfo.productKey }}
                                        <el-button type="text" class="copy" v-clipboard="baseInfo.productKey"
                                            v-clipboard:success="copySuccess" v-clipboard:error="copyError">
                                            <img src="../../../assets/images/copy.png" alt="">
                                        </el-button>
                                    </el-descriptions-item>
                                    <el-descriptions-item label="DeviceSecret">{{ encrypt(baseInfo.deviceSecret,2,2) }}
                                        <el-button type="text" class="copy" v-clipboard="baseInfo.deviceSecret"
                                            v-clipboard:success="copySuccess" v-clipboard:error="copyError">
                                            <img src="../../../assets/images/copy.png" alt="">
                                        </el-button>
                                    </el-descriptions-item>
                                    <el-descriptions-item label="产品名称">{{ baseInfo.productName }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="iotId">{{ encrypt(baseInfo.iotId,2,2) }}
                                        <el-button type="text" class="copy" v-clipboard="baseInfo.iotId"
                                            v-clipboard:success="copySuccess" v-clipboard:error="copyError">
                                            <img src="../../../assets/images/copy.png" alt="">
                                        </el-button>
                                    </el-descriptions-item>
                                    <el-descriptions-item label="所属区域">
                                        <span v-if="baseInfo.region == 'cn'">中国区</span>
                                        <span v-if="baseInfo.region == 'eu'">欧洲区</span>
                                        <span v-if="baseInfo.region == 'us'">北美区</span>
                                        <span v-if="baseInfo.region == 'ap'">亚太区</span>
                                    </el-descriptions-item>
                                    <el-descriptions-item label="国家/地区">{{ baseInfo.country && baseInfo.country !=
                                    '0'?baseInfo.country : '--' }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="省份/州">{{ baseInfo.province && baseInfo.province !=
                                    '0'?baseInfo.province : '--' }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="城市">{{ baseInfo.city && baseInfo.city !=
                                    '0'?baseInfo.city : '--' }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="设备昵称">{{ baseInfo.nickname || '--' }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="设备类型">{{ baseInfo.thingType = 'DEVICE' ?'设备':'--' }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="设备固件版本">{{ baseInfo.firmwareVersion || '--' }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="IP地址">{{ baseInfo.ipAddress || '--' }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="设备mac地址">{{ baseInfo.mac || '--'}}
                                    </el-descriptions-item>
                                    <!-- <el-descriptions-item label="">
                                    </el-descriptions-item> -->
                                    <el-descriptions-item label="设备创建时间">{{ formDate(baseInfo.gmtCreate) || '--' }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="设备激活时间">{{ formDate(baseInfo.activeTime) || '--' }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="最后上线时间">{{ formDate(baseInfo.onlineTime) || '--' }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="最后更新时间">{{ formDate(baseInfo.gmtModified) || '--' }}
                                    </el-descriptions-item>
                                </el-descriptions>
                            </el-tab-pane>
                            <el-tab-pane label="运行状态" name="b">
                                <div class="refresh">
                                    <el-button type="text" @click="refresh">
                                        <i class="el-icon-refresh"></i><span>刷新</span>
                                    </el-button>
                                </div>
                                <div class="cards">
                                    <div class="card_box" v-if="!isCatBox && !isFeeder">
                                        <div v-for="(item,i) in baseInfo.thingModel" class="card" :key="i + '1234786'" v-if="statList.indexOf(i) != -1"">
                                            <div v-if="i=='WindPower'">
                                                <p class="card_title">当前机器风力</p>
                                                <p class="card_val"> {{item.value || '--'}}</p>
                                                <p class="card_time">{{formDate(item.time)}}</p>
                                            </div>
                                            <div v-else-if="i=='Water'">
                                                <p class="card_title">水箱档位</p>
                                                <p class="card_val"> {{item.value || '--'}}</p>
                                                <p class="card_time">{{formDate(item.time)}}</p>
                                            </div>
                                            <div v-else-if="i=='WifiIp'">
                                                <p class="card_title">IP地址</p>
                                                <p class="card_val"> {{item.value || '--'}}</p>
                                                <p class="card_time">{{formDate(item.time)}}</p>
                                            </div>
                                            <div v-else-if="i=='RunTimes'">
                                                <p class="card_title">运行次数</p>
                                                <p class="card_val"> {{item.value || '--'}}</p>
                                                <p class="card_time">{{formDate(item.time)}}</p>
                                            </div>
                                            <div v-else-if="i=='McuVersion'">
                                                <p class="card_title">Mcu版本号</p>
                                                <p class="card_val"> {{item.value || '--'}}</p>
                                                <p class="card_time">{{formDate(item.time)}}</p>
                                            </div>
                                            <div v-else-if="i=='CleanAreas'">
                                                <p class="card_title">本次清扫面积</p>
                                                <p class="card_val"> {{item.value || '--'}}㎡</p>
                                                <p class="card_time">{{formDate(item.time)}}</p>
                                            </div>
                                            <div v-else-if="i=='CleanRunTime'">
                                                <p class="card_title">本次清扫时间</p>
                                                <p class="card_val"> {{item.value || '--'}}s</p>
                                                <p class="card_time">{{formDate(item.time)}}</p>
                                            </div>
                                            <div v-else-if="i=='TotalCleanAreas'">
                                                <p class="card_title">设备总清扫面积</p>
                                                <p class="card_val"> {{item.value || '--'}}㎡</p>
                                                <p class="card_time">{{formDate(item.time)}}</p>
                                            </div>
                                            <div v-else-if="i=='TotalCleanTimes'">
                                                <p class="card_title">设备总清扫时间</p>
                                                <p class="card_val"> {{item.value || '--'}}s</p>
                                                <p class="card_time">{{formDate(item.time)}}</p>
                                            </div>
                                            <div v-else-if="i=='Vol'">
                                                <p class="card_title">机器音量</p>
                                                <p class="card_val"> {{item.value || '--'}}</p>
                                                <p class="card_time">{{formDate(item.time)}}</p>
                                            </div>
                                            <div v-else-if="i=='FilterTime'">
                                                <p class="card_title">滤网使用时间</p>
                                                <p class="card_val"> {{item.value || '--'}}min</p>
                                                <p class="card_time">{{formDate(item.time)}}</p>
                                            </div>
                                            <div v-else-if="i=='SideBrushTime'">
                                                <p class="card_title">边刷使用时间</p>
                                                <p class="card_val"> {{item.value || '--'}}min</p>
                                                <p class="card_time">{{formDate(item.time)}}</p>
                                            </div>
                                            <div v-else-if="i=='SensorTime'">
                                                <p class="card_title">传感器使用时间</p>
                                                <p class="card_val"> {{item.value || '--'}}min</p>
                                                <p class="card_time">{{formDate(item.time)}}</p>
                                            </div>
                                            <div v-else-if="i=='MainBrushTime'">
                                                <p class="card_title">主刷使用时间</p>
                                                <p class="card_val"> {{item.value || '--'}}min</p>
                                                <p class="card_time">{{formDate(item.time)}}</p>
                                            </div>
                                            <div v-else-if="i=='BatteryState'">
                                                <p class="card_title">电池状态</p>
                                                <p class="card_val"> {{item.value || '--'}}%</p>
                                                <p class="card_time">{{formDate(item.time)}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div  class="card_box cat_box" v-else-if="isCatBox">
                                        <div v-for="item in catBoxRunStateConfig" class="card" :key="item.key" v-if="baseInfo.thingModel[item.key]">
                                            <div>
                                                <p class="card_title">{{ item.name }}</p>
                                                <p class="card_val">
                                                    <span>{{ baseInfo.thingModel[item.key].value }}</span>
                                                    <span class="caption" v-if="item.caption">{{ `(${item.caption[baseInfo.thingModel[item.key].value]})` }}</span>
                                                </p>
                                                <p class="card_time">{{ formDate(baseInfo.thingModel[item.key].time) }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div  class="card_box" v-else-if="isFeeder">
                                        <div v-for="(item,key) in baseInfo.thingModel" class="card" :key="key">
                                            <div>
                                                <p class="card_title">{{ key }}</p>
                                                <p class="card_val">{{ item.value || '--' }}</p>
                                                <p class="card_time">{{ formDate(item.time) }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="设备动态信息" name="c">
                                <div class="search_box">
                                    <el-form :inline="true" class="demo-form-inline search-form form-list"
                                        label-width="80px">
                                        <el-form-item>
                                            <el-select v-model="searchData.type" placeholder="类型" clearable
                                                @change="getIotMarkList">
                                                <!-- <el-option label=" " :value="-1"></el-option> -->
                                                <el-option label="属性" value="1"></el-option>
                                                <el-option label="事件" value="2"></el-option>
                                                <el-option label="服务" value="3"></el-option>
                                                <el-option label="设备状态变更" value="4"></el-option>
                                                <el-option label="绑定信息变更" value="5"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item>
                                            <el-select v-model="searchData.mark" placeholder="标识符" clearable>
                                                <el-option v-for="item in markList" :key="item" :label="item"
                                                    :value="item"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="时间" class="form_item date_picker">
                                            <el-date-picker v-model="createTime" type="datetimerange"
                                                range-separator="至" v-if="$store.state.type == 'pc'"
                                                start-placeholder="开始日期" end-placeholder="结束日期"
                                                :default-time="['00:00:00','23:59:59']" value-format="timestamp"
                                                :clearable="false"
                                                :picker-options="pickerOptions">
                                            </el-date-picker>
                                            <DatePicker v-else :date="createTime" @dateSelect="dateSelect"></DatePicker>
                                        </el-form-item>
                                        <el-form-item>
                                            <div class="button search" @click="search">
                                                <span>查询</span>
                                            </div>
                                            <div class="button search white" @click="init">
                                                <span>重置</span>
                                            </div>
                                        </el-form-item>
                                    </el-form>
                                </div>
                                <el-table :data="activeList" highlight-current-row :fit="true" style="width:100%">
                                    <el-table-column prop="time" label="时间" width="200">
                                        <template slot-scope="scope">
                                            <span>{{ formDate(scope.row.time) }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="type" label="类型">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.type == 1">属性</span>
                                            <span v-if="scope.row.type == 2">事件</span>
                                            <span v-if="scope.row.type == 3">服务</span>
                                            <span v-if="scope.row.type == 4">设备状态变更</span>
                                            <span v-if="scope.row.type == 5">绑定信息变更</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="mark" label="标识符">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.mark || '--' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="mark_val" label="标识符名称">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.mark_val || '--' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="value" label="结果值">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.value || '--' }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <Pagination :total="activeTotal" :page="searchData.page"
                                    @paginationChange="paginationChange" class="pagination">
                                </Pagination>
                            </el-tab-pane>
                            <el-tab-pane label="设备绑定信息" name="d">
                                <p class="table_title">用户列表</p>
                                <el-table :data="userList" highlight-current-row :fit="true" style="width:100%">
                                    <el-table-column prop="user_name" label="用户名" show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.user_name ||'--'}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="owned" label="绑定关系" show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.owned == 1">主用户</span>
                                            <span v-if="scope.row.owned == 0">用户</span>
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column prop="last_update" label="绑定时间"></el-table-column> -->
                                    <el-table-column prop="act" label="操作">
                                        <template slot-scope="scope">
                                            <div class="btn_flex">
                                                <div class="btn"
                                                    v-if="roleCheck('104-102-101-102') && scope.row.ali_user_id">
                                                    <div class="button text" @click="goUser(scope.row.ali_user_id)">
                                                        <span>查看用户</span>
                                                    </div>
                                                </div>
                                                <div class="btn" v-if="roleCheck('104-102-101-102')">
                                                    <div class="button text"
                                                        @click="unboundConfirm(scope.row.ali_open_id)">
                                                        <span>解绑</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- <span v-else>--</span> -->
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <p class="table_title table_title1">设备绑定历史记录</p>
                                <el-table :data="bindList" highlight-current-row :fit="true" style="width:100%">
                                    <el-table-column prop="user_name" label="用户名">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.user_name && scope.row.user_name != ''?
                                            scope.row.user_name : '--' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="mark_val" label="操作">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.mark_val || '--' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="time" label="绑定时间">
                                        <template slot-scope="scope">
                                            <span>{{ formDate(scope.row.time) }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-tab-pane>
                            <el-tab-pane label="设备定时任务" name="g">
                                <el-table :data="deviceMsgData" highlight-current-row :fit="true" style="width:100%">
                                    <el-table-column prop="id" label="ID" width="100"></el-table-column>
                                    <el-table-column prop="account" label="账号"></el-table-column>
                                    <el-table-column label="用户ID">
                                        <template slot-scope="scope">
                                            <div class="button text" @click.stop="goUser(scope.row.user_id)">
                                                <span>{{ scope.row.user_id }}</span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="task_type" label="任务类型"></el-table-column>
                                    <el-table-column prop="status" label="任务状态"></el-table-column>
                                    <el-table-column prop="cycle" label="周期">
                                        <template slot-scope="scope">
                                           <span>{{ scope.row.cycle + scope.row.unit }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="click_time" label="提醒时间" width="120"></el-table-column>
                                    <el-table-column prop="next_click_time" label="下次提醒时间" width="180"></el-table-column>
                                    <el-table-column prop="create_time" label="创建时间" width="180"></el-table-column>
                                    <el-table-column prop="update_time" label="更新" width="180"></el-table-column>
                                </el-table>
                            </el-tab-pane>
                            <template  v-if="isCatBox">
                                <el-tab-pane label="设备记录" name="e">
                                    <div class="search_box">
                                        <el-form :inline="true" class="demo-form-inline search-form form-list" label-width="80px">
                                            <el-form-item>
                                                <el-select v-model="searchLogData.type" placeholder="行为类型" clearable>
                                                    <el-option label="掩埋" value="Bury"></el-option>
                                                    <el-option label="清理" value="Clean"></el-option>
                                                    <el-option label="如厕" value="Toilet"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-select v-model="searchLogData.way" placeholder="方式" clearable>
                                                    <el-option label="手动" :value="0"></el-option>
                                                    <el-option label="自动" :value="1"></el-option>
                                                    <el-option label="周期" :value="2"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="时间" class="form_item date_picker">
                                                <el-date-picker v-model="createTimeLog" type="datetimerange"
                                                    range-separator="至" v-if="$store.state.type == 'pc'"
                                                    start-placeholder="开始日期" end-placeholder="结束日期"
                                                    :default-time="['00:00:00','23:59:59']" value-format="timestamp"
                                                    :clearable="true"
                                                    :picker-options="pickerOptions">
                                                </el-date-picker>
                                                <DatePicker v-else :date="createTimeLog" @dateSelect="logDateSelect"></DatePicker>
                                            </el-form-item>
                                            <el-form-item>
                                                <div class="button search" @click="searchLog">
                                                    <span>查询</span>
                                                </div>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                    <el-table :data="logList" highlight-current-row :fit="true" style="width:100%">
                                        <el-table-column prop="type" label="记录类型">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.type == 'Bury'">掩埋</span>
                                                <span v-if="scope.row.type == 'Clean'">清理</span>
                                                <span v-if="scope.row.type == 'Toilet'">如厕</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="record_id" label="记录ID"></el-table-column>
                                        <el-table-column prop="user_id" label="用户ID">
                                            <template slot-scope="scope">
                                                <div class="button text" @click.stop="goUser(scope.row.user_id)">
                                                    <span>{{ scope.row.user_id }}</span>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="账号" width="120">
                                            <template slot-scope="scope">
                                                <span>{{scope.row.phone || scope.row.email || '--'}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="device_name" label="设备ID" width="190"></el-table-column>
                                        <el-table-column label="记录体重" width="190">
                                            <template slot-scope="scope">
                                                <span>{{scope.row.record_weight ? scope.row.record_weight + 'kg/' + (scope.row.record_weight*2.2).toFixed(2) + 'lb' : '--'}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="猫咪体重" width="190">
                                            <template slot-scope="scope">
                                                <span>{{scope.row.weight ? scope.row.name + '(' + scope.row.weight + scope.row.unit + ')' : '--'}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="way" label="方式">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.way === '0'">手动</span>
                                                <span v-else-if="scope.row.way === '1'">自动</span>
                                                <span v-else-if="scope.row.way == '2'">周期</span>
                                                <span v-else></span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="start_time" label="开始时间" width="160"></el-table-column>
                                        <el-table-column prop="end_time" label="结束时间" width="160"></el-table-column>
                                        <el-table-column prop="UpTime" label="上报时间" width="160"></el-table-column>
                                    </el-table>
                                    <Pagination :total="logTotal" :page="searchLogData.page"
                                        @paginationChange="paginationChange" class="pagination">
                                    </Pagination>
                                </el-tab-pane>
                                <el-tab-pane label="猫咪数据" name="f">
                                    <el-table :data="catData" highlight-current-row :fit="true" style="width:100%">
                                        <el-table-column prop="id" label="ID"></el-table-column>
                                        <el-table-column prop="user_id" label="用户ID">
                                            <template slot-scope="scope">
                                                <div class="button text" @click.stop="goUser(scope.row.user_id)">
                                                    <span>{{ scope.row.user_id }}</span>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="name" label="昵称"></el-table-column>
                                        <el-table-column label="体重">
                                            <template slot-scope="scope">
                                                <span>{{scope.row.weight + scope.row.unit}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="头像">
                                            <template slot-scope="scope">
                                                <el-avatar :src="scope.row.avatar"></el-avatar>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="birthday" label="生日"></el-table-column>
                                        <el-table-column label="性别">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.gender === 1">公</span>
                                                <span v-else-if="scope.row.gender == 2">母</span>
                                                <span v-else>-</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="入库时间" width="160">
                                            <template slot-scope="scope">
                                                <span>{{ formDate(scope.row.create_time) }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="更新时间" width="160">
                                            <template slot-scope="scope">
                                                <span>{{ formDate(scope.row.update_time || scope.row.create_time) }}</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <Pagination :total="catDataTotal" :page="searchCatData.page"
                                        @paginationChange="paginationChange" class="pagination">
                                    </Pagination>
                                </el-tab-pane>
                            </template>
                            <template  v-if="isFeeder">
                                <el-tab-pane label="设备记录" name="h">
                                    <div class="search_box">
                                        <el-form :inline="true" class="demo-form-inline search-form form-list" label-width="80px">
                                            <el-form-item>
                                                <el-select v-model="searchFeederData.record_type" placeholder="记录类型" clearable>
                                                    <el-option label="全部" value=""></el-option>
                                                    <el-option label="喂食记录" value="feed"></el-option>
                                                    <el-option label="进食记录" value="eat"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-select v-model="searchFeederData.way" placeholder="喂食方式" clearable>
                                                    <el-option label="手动" value="manual"></el-option>
                                                    <el-option label="自动" value="auto"></el-option>
                                                    <el-option label="自动补水" value="reflesh"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-select v-model="searchFeederData.status" placeholder="出餐状态" clearable>
                                                    <el-option label="全部" :value="-1"></el-option>
                                                    <el-option label="成功" :value="1"></el-option>
                                                    <el-option label="失败" :value="2"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="时间" class="form_item date_picker">
                                                <el-date-picker v-model="createTimeFeeder" type="datetimerange"
                                                    range-separator="至" v-if="$store.state.type == 'pc'"
                                                    start-placeholder="开始日期" end-placeholder="结束日期"
                                                    :default-time="['00:00:00','23:59:59']" value-format="timestamp"
                                                    :clearable="true"
                                                    :picker-options="pickerOptions">
                                                </el-date-picker>
                                                <DatePicker v-else :date="createTimeFeeder" @dateSelect="feederDateSelect"></DatePicker>
                                            </el-form-item>
                                            <el-form-item>
                                                <div class="button search" @click="searchFeederLog">
                                                    <span>查询</span>
                                                </div>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                    <el-table :data="feederList" highlight-current-row :fit="true" style="width:100%">
                                        <el-table-column label="记录类型" width="80">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.record_type == 'feed'">喂食</span>
                                                <span v-else-if="scope.row.record_type == 'eat'">进食</span>
                                            </template>
                                        </el-table-column>
                                        <!-- 喂食记录列 -->
                                        <el-table-column label="喂食方式" width="90" v-if="!searchFeederData.record_type || searchFeederData.record_type == 'feed'">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.way == 'manual'">手动</span>
                                                <span v-else-if="scope.row.way == 'auto'">自动</span>
                                                <span v-else-if="scope.row.way == 'reflesh'">补水</span>
                                                <span v-else>{{scope.row.way}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="实际喂食(g)" width="90" v-if="!searchFeederData.record_type || searchFeederData.record_type == 'feed'">
                                            <template slot-scope="scope">
                                                <span>{{scope.row.feed_weight || '--'}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="实际喂水(g)" width="90" v-if="!searchFeederData.record_type || searchFeederData.record_type == 'feed'">
                                            <template slot-scope="scope">
                                                <span>{{scope.row.water_weight || '--'}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="出餐状态" width="80" v-if="!searchFeederData.record_type || searchFeederData.record_type == 'feed'">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.status == 1">成功</span>
                                                <span v-else-if="scope.row.status == 2">失败</span>
                                                <span v-else>{{scope.row.status}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="失败原因" v-if="!searchFeederData.record_type || searchFeederData.record_type == 'feed'">
                                            <template slot-scope="scope">
                                                <span>{{scope.row.fail_reason || '--'}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="喂食时间" width="150" v-if="!searchFeederData.record_type || searchFeederData.record_type == 'feed'">
                                            <template slot-scope="scope">
                                                <span>{{scope.row.feed_time_str || '--'}}</span>
                                            </template>
                                        </el-table-column>
                                        <!-- 进食记录列 -->
                                        <el-table-column label="猫咪名称" width="90" v-if="!searchFeederData.record_type || searchFeederData.record_type == 'eat'">
                                            <template slot-scope="scope">
                                                <span>{{scope.row.cat_name || '--'}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="芯片ID" width="120" v-if="!searchFeederData.record_type || searchFeederData.record_type == 'eat'">
                                            <template slot-scope="scope">
                                                <span>{{scope.row.cat_chip_id || '--'}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="进食重量(g)" width="100" v-if="!searchFeederData.record_type || searchFeederData.record_type == 'eat'">
                                            <template slot-scope="scope">
                                                <span>{{scope.row.eat_weight || '--'}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="碗内剩余(g)" width="100" v-if="!searchFeederData.record_type || searchFeederData.record_type == 'eat'">
                                            <template slot-scope="scope">
                                                <span>{{scope.row.eat_left_weight || '--'}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="开始时间" width="150" v-if="!searchFeederData.record_type || searchFeederData.record_type == 'eat'">
                                            <template slot-scope="scope">
                                                <span>{{scope.row.start_time_str || '--'}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="结束时间" width="150" v-if="!searchFeederData.record_type || searchFeederData.record_type == 'eat'">
                                            <template slot-scope="scope">
                                                <span>{{scope.row.end_time_str || '--'}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="上报时间" width="150">
                                            <template slot-scope="scope">
                                                <span>{{scope.row.up_time || '--'}}</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <Pagination :total="feederTotal" :page="searchFeederData.page"
                                        @paginationChange="paginationChange" class="pagination">
                                    </Pagination>
                                </el-tab-pane>
                            </template>
                        </el-tabs>
                    </template>
                </div>
                <Tip ref="Tip" msg="确定要解绑设备吗，解绑后不能再恢复哦！" title="解绑设备">
                    <template v-slot:confirm_btn>
                        <div class="button del" @click="unbound">
                            <span>确定</span>
                        </div>
                    </template>
                </Tip>
            </div>

        </div>
    </div>
</template>
<script>
import catBoxRunStateConfig from '../../../js/catBoxRunStateConfig'
export default ({
    name: 'device-detail',
    data() {
        return {
            activeName: 'a',
            ali_user_id: '',
            baseInfo: [],
            activeList: [],
            logList: [],
            userList: [],
            bindList: [],
            catBoxRunStateConfig: [],
            unboundData: {
                open_id: '',
                iot_id: '',
            },
            searchData: {
                page_size: 10,
                page: 1,
                type: '',
                mark: '',
                end_time: '',
                start_time: '',
            },
            searchLogData: {
                device_name: '',
                page_size: 10,
                page: 1,
                type: '',
                start_stamp: '',
                end_stamp: '',
                way: ''
            },
            activeTotal: 0,
            logTotal: 0,
            createTime: [],
            createTimeLog: [],
            searchFeederData: {
                device_name: '',
                page_size: 10,
                page: 1,
                record_type: '',
                way: '',
                status: -1,
                cat_id: '',
                start_stamp: '',
                end_stamp: '',
            },
            feederList: [],
            feederTotal: 0,
            createTimeFeeder: [],
            pickerOptions: {
                disabledDate(time) {
                    const date = new Date();
                    return time.getTime() > Date.now() + ((23 - date.getHours()) * 3600 + (59 - date.getMinutes()) * 60 + (59 - date.getSeconds())) * 1000 - date.getMilliseconds();
                },
                shortcuts: [{
                    text: '最近一小时',
                    onClick(picker) {
                        const date = new Date();
                        const end = date.getTime();
                        const start = end - 3600 * 1000;
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近24小时',
                    onClick(picker) {
                        const date = new Date();
                        const end = date.getTime();
                        const start = end - 3600 * 1000 * 24;
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近7天',
                    onClick(picker) {
                        const date = new Date();
                        const end = date.getTime();
                        const start = end - 3600 * 1000 * 24 * 7;
                        picker.$emit('pick', [start, end]);
                    }
                },]
            },
            statList: ['WindPower', 'Water', 'WifiIp', 'RunTimes', 'McuVersion', 'CleanAreas', 'CleanRunTime', 'TotalCleanAreas', 'TotalCleanTimes', 'Vol', 'FilterTime', 'SideBrushTime', 'SensorTime', 'MainBrushTime', 'BatteryState'],
            markList: [],
            searchCatData: {
                device_name: '',
                page_size: 10,
                page: 1
            },
            catData: [],
            catDataTotal: 0,
            deviceMsgData: []
        };
    },
    computed: {
        // 猫砂盆类设备：这几种产品共用仓门操作/猫砂盆运行状态/设备记录/猫咪数据等展示逻辑
        isCatBox() {
            var catBoxProducts = ['Neakasa_M1', 'Neakasa_M9', '猫砂盆'];
            return catBoxProducts.indexOf(this.baseInfo.productName) != -1;
        },
        // 喂食器类设备
        isFeeder() {
            var feederProducts = ['Riko'];
            return feederProducts.indexOf(this.baseInfo.productName) != -1;
        }
    },
    created() {
        this.getIotMarkList();
        this.catBoxRunStateConfig = catBoxRunStateConfig;
    },
    activated() {
        this.activeName = 'a';
        this.init();
        this.getInfo();
    },
    watch: {
        createTime: function (nTime) {
            if (nTime.length > 1) {
                this.searchData.start_time = this.formDate(nTime[0], "YYYY-MM-DD'T'HH:mm:ss'Z'");
                this.searchData.end_time = this.formDate(nTime[1], "YYYY-MM-DD'T'HH:mm:ss'Z'");
            } else {
                this.searchData.start_time = '';
                this.searchData.end_time = '';
            }
        },
        createTimeLog: function (nTime) {
            if (nTime && nTime.length > 1) {
                this.searchLogData.start_stamp = nTime[0] / 1000;
                this.searchLogData.end_stamp = nTime[1] / 1000;
            } else {
                this.searchLogData.start_stamp = '';
                this.searchLogData.end_stamp = '';
            }
        },
        createTimeFeeder: function (nTime) {
            if (nTime && nTime.length > 1) {
                this.searchFeederData.start_stamp = nTime[0] / 1000;
                this.searchFeederData.end_stamp = nTime[1] / 1000;
            } else {
                this.searchFeederData.start_stamp = '';
                this.searchFeederData.end_stamp = '';
            }
        },
        activeName: function (n) {
            if (n == 'c') {
                this.getIotDeviceActive();
            } else if (n == 'd') {
                this.getIotDeviceBind();
                this.getBindList();
            } else if (n == 'e') {
                this.searchLog();
            }else if (n == 'f') {
                this.getCatData();
            }else if (n == 'g') {
                this.getDeviceMsg();
            }else if (n == 'h') {
                this.searchFeederLog();
            }

        }
    },
    methods: {
        init() {
            this.iotId = this.$route.params.id;
            this.deviceName = this.$route.query.deviceName;
            this.productKey = this.$route.query.productKey;
            this.searchLogData.device_name = this.$route.query.deviceName;
            this.searchCatData.device_name = this.$route.query.deviceName;
            this.searchFeederData.device_name = this.$route.query.deviceName;
            this.searchData = {
                iotId: this.$route.params.id,
                page_size: 10,
                page: 1,
                type: '',
                mark: '',
                end_time: 0,
                start_time: 0,
            };
            this.createTime = this.setDate(7);
            this.getIotMarkList();
        },
        doorHandle(handle){	
			this.api.iotDeviceDoorHandle({
				iot_id: this.iotId, 
				region: this.baseInfo.region,
				identifier: 'setDoor',
				value_map: {
					enable: handle === 'open' ? 1 : 0
				}						
			}).then(data => {
				if(data.code == 200 || data.code == 0) {
					this.$message.success(handle === 'open' ? '开启成功!' : '关闭成功!');
				}
				
			})					
        },
        dateSelect(date) {
            this.createTime = [...date];
        },
        logDateSelect(date) {
            this.createTimeLog = [...date];
        },
        feederDateSelect(date) {
            this.createTimeFeeder = [...date];
        },
        search() {
            this.searchData.page = 1;
            this.getIotDeviceActive();
        },
        searchLog() {
            this.searchLogData.page = 1;
            this.getLogList();
        },
        getIotMarkList(data) {
            var req = {};
            if (data) {
                req = { type: String(data) };
            }
            this.searchData.mark = '';
            this.api.getIotMarkList(req).then(data => {
                this.markList = data.data.keys;
            })
        },
        getInfo() {
            this.api.getIotDeviceDetail({ iotId: this.iotId, productKey: this.productKey }).then(data => {
                this.baseInfo = data.data.result[0];
            })
        },
        getIotDeviceActive() {
            this.api.getIotDeviceActive(this.searchData).then(data => {
                this.activeList = data.data.result || [];
                this.activeTotal = data.data.total;
            })
        },
        paginationChange(data) {
            if(this.activeName == 'c') {
                this.searchData.page_size = data.page_size;
                this.searchData.page = data.page;
                this.getIotDeviceActive();
            }else if(this.activeName == 'e'){
                this.searchLogData.page_size = data.page_size;
                this.searchLogData.page = data.page;
                this.getLogList();
            }else if(this.activeName == 'f'){
                this.searchCatData.page_size = data.page_size;
                this.searchCatData.page = data.page;
                this.getCatData();
            }else if(this.activeName == 'g'){
                this.searchCatData.page_size = data.page_size;
                this.searchCatData.page = data.page;
                this.getDeviceMsg();
            }else if(this.activeName == 'h'){
                this.searchFeederData.page_size = data.page_size;
                this.searchFeederData.page = data.page;
                this.getFeederLogList();
            }
        },
        getIotDeviceBind() {
            const p = {
                iot_id: this.iotId,
                device_name: this.deviceName,
                product_key: this.baseInfo.productKey
            };
            this.api.getIotDeviceBindUser(p).then(data => {
                this.userList = data.data || [];
            })
        },
        getBindList() {
            var req = {
                type: '5',
                iotId: this.iotId,
                end_time: '',
                start_time: '',
            }
            this.api.getIotDeviceActive(req).then(data => {
                this.bindList = data.data.result || [];
                // console.log(this.bindList)
            })
        },
        unboundConfirm(openId) {
            this.$refs.Tip.show = true;
            this.unboundData.open_id = openId;
            this.unboundData.iot_id = this.iotId
        },
        unbound() {
            this.api.deviceUnbound(this.unboundData).then(data => {
                this.getIotDeviceBind();
                this.$message.success('解绑成功!');
                this.$refs.Tip.show = false;
            })
        },
        refresh() {
            this.activeName = 'b',
                this.getInfo();
        },
        copySuccess(v) {
            this.$message.success('复制成功!');
        },
        copyError() {
            this.$message.error('复制失败!');
        },
        goUser(ali_user_id) {
            if (ali_user_id == '') {
                this.$message.error('未查询到该用户!');
                return;
            }
            if (window.h5sdk) {
                this.$router.push({ name: 'user-detail', params: { id: ali_user_id }, query: { region: this.baseInfo.region } });
                return;
            }
            const page = this.$router.resolve({
                name: 'user-detail',
                params: { id: ali_user_id }, query: { region: this.baseInfo.region }
            });
            window.open(page.href, "_blank");
        },
        getLogList() {
            let logData = {...this.searchLogData};
            logData.way = this.searchLogData.way === '' ? -1 : this.searchLogData.way;
            this.api.getDeviceLog(logData).then(data => {
                this.logList = data.data.result || [];
                this.logTotal = data.data.total;
            })
        },
        searchFeederLog() {
            this.searchFeederData.page = 1;
            this.getFeederLogList();
        },
        getFeederLogList() {
            this.api.getFeederRecord(this.searchFeederData).then(data => {
                this.feederList = data.data.result || [];
                this.feederTotal = data.data.total;
            })
        },
        getCatData() {
            this.api.getCatData(this.searchCatData).then(data => {
                this.catData = data.data.list || [];
                this.catDataTotal = data.data.total;
            })
        },
        getDeviceMsg() {
            this.api.getIotDeviceMsg(this.searchCatData).then(data => {
                this.deviceMsgData = data.data;
            })
        }
    }
});
</script>
<style>
    .el-picker-panel__footer .el-picker-panel__link-btn.el-button--text {
        display: none;
    }
</style>
<style lang="less" scoped>
.content_box {
    padding: 0;

}

.content {
    background: none;
    padding: 0;
    border-radius: 0;

    .top {
        .flexLayout(space-between);
        padding: 20px;
        background-color: @colorWhite;
    }

    /deep/ .el-descriptions-item__label:not(.is-bordered-label) {
        color: #868998;
    }
    /deep/.el-descriptions__body{
        color: #333;
    }

}

.user {
    padding: 20px;
    min-height: calc(100% - 275px);

    .header {
        padding: 20px;
        margin-bottom: 20px;
        border-radius: 24px;
        background-color: white;

        .info_title {
            font-size: 16px;
            font-weight: 600;
        }

        .status1 {
            color: #00D6B9;
        }

        .status2 {
            color: #F8AF0C;
        }

        .status3 {
            color: #EB534B;
        }
		/deep/ .el-descriptions-item__container .el-descriptions-item__label{
			align-items: center;
		}
    }

    .main {
        padding: 20px;
        border-radius: 24px;
        background-color: white;
        min-height: 100%;

        .login_info {
            padding-top: 15px;
        }

        .font_size {
            // font-size: 14px;
            font-weight: bold;
        }

        .pagination {
            margin-bottom: 5px;
        }

        .pagination1 {
            padding: 10px 5px;
        }

        /deep/ .el-form-item {
            margin-bottom: 0;
        }

        /deep/ .el-form.form-list .form_item.date_picker .el-form-item__content .el-input__inner {
            width: 370px;
        }

        .refresh {
            position: absolute;
            right: 0;
        }

        .card_box {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
            gap: 30px;
            padding-top: 30px;
            .card {
                background: #EDF5FD;
                border-radius: 12px;
                line-height: 35px;
                padding: 5px 14px;
                .card_val {
                    font-size: 20px;
                    font-weight: 600;
                }

                .card_time {
                    color: #868998;
                    font-size: 14px;
                }
            }
            &.cat_box{
                grid-template-columns: 1fr 1fr 1fr;
                .card {
                    .card_val {
                        font-size: 14px;
                        line-height: 1.7;
                        .caption{
                            font-size: 17px;
                        }
                    }
                }
            }
        }

        .table_title {
            font-size: 16px;
            font-weight: 600;
        }

        .table_title1 {
            padding-top: 20px;
        }


        /deep/ .el-tabs__item {
            font-weight: 700;
            font-size: 16px;
        }

        /deep/ .el-tabs__nav-wrap::after {
            background-color: #EBEEF5;
            height: 1px;
        }

        /deep/ .el-tabs__active-bar {
            height: 1px;
        }
    }

    .copy {
        padding: 0 5px;

        img {
            width: 14px;
        }
    }

    .btn_flex {
        display: inline-flex;
    }

    // /deep/ .el-descriptions-item__container {
    //     align-items: center;
    // }
}
</style>



// WEBPACK FOOTER //
// src/view/iot/device-manage/device-detail.vue